import { useState } from "react";
import { downloadRequest } from "@/utils/downloadRequest";
import routerUtil from "@/utils/routerUtil";
import { message } from "antd";
import { useTranslation } from "react-i18next";

export function useExportList(searchParams?: Record<string, any>) {
  const { t } = useTranslation("center");

  const [openExportModal, setOpenExportModal] = useState(false);
  const [exportType, setExportType] = useState(0);

  const onExport = async () => {
    await downloadRequest(
      "/api/rendering/task/renderingTask/exportConsumptionList",
      { ...searchParams, exportType }
    );
    message.success(t("header_user_add_export_list"));

    setTimeout(() => routerUtil.navigate?.("/exportList"), 2000);
    return;
  };

  return {
    exportType,
    setExportType,
    onExport,
    openExportModal,
    setOpenExportModal,
  };
}
